import React from 'react'
import { ICONS } from '@Const/common'
import { LegacyRecording } from '@Entities/matching/recording-group-details'

interface RecordingDataSectionProps {
    recordingData: LegacyRecording
}

const RecordingDataSection = (props: RecordingDataSectionProps) => {
    const { recordingData } = props
    const { isrc, recordingTitle, recordingDisplayArtistName, duration, label } = recordingData
    return (
        <>
            <div className="section-header">
                <img src={ICONS.recordingData} alt="Recording Data" />
                <h5>Recording Data</h5>
            </div>
            <div className="details recording-details">
                <div className="horizontal-detail-pair">
                    <p className="label">ISRC:</p>
                    <p className="semi-bold">{isrc || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Recording Title:</p>
                    <p className="semi-bold">{recordingTitle || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Recording Artist:</p>
                    <p className="semi-bold">{recordingDisplayArtistName.join(', ') || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Duration:</p>
                    <p className="semi-bold">
                        {`${Math.floor(duration / 60)}m : ${
                            duration % 60 > 10 ? duration % 60 : '0' + (duration % 60)
                        }s`}
                    </p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Label Name:</p>
                    <p className="semi-bold">{label || 'NA'}</p>
                </div>
            </div>
        </>
    )
}

export default RecordingDataSection
